<script lang="ts">
    import { user } from './stores/login_store.js'
    import { onMount } from 'svelte'

    import page from 'page'

    import Nav from './Nav.svelte'
    import Splash from './Splash.svelte'
    import PasteList from './PasteList.svelte'
    import PasteCreate from './PasteCreate.svelte'
    import PasteView from './PasteView.svelte'
    import NotFound from './NotFound.svelte'

    let current = Splash
    let params

    onMount( async () => {
        // todo: caching
        let profile = await pb.download_profile()
        user.set(profile)

    })

    page('/', () => {
        current = PasteList
    })

    page('/view/:paste_id',
        (ctx, next) => {
            params = {
                render_markdown: ctx.querystring === 'm',
                ...ctx.params
            }
            next()
        },
        () => {
            current = PasteView
        }
    )

    page('/view/:paste_id/raw', 
        ctx => {
            page.stop()
            location.href = ctx.path
        }
    )

    page('/create', () => {
        current = PasteCreate
    })

    page('/auth/*', ctx => {
        page.stop()
        location.href = ctx.path
    })

    page('*', () => {
        current = NotFound
    })

    page.start()
</script>

<style type="text/css">
    main {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: stretch;
    }
</style>

<main>
    {#if $user}
        {#if current !== PasteCreate}
            <Nav/>
        {/if}
        <svelte:component this={current} {...params}/>
    {:else}
        {#if current === PasteView}
            <Nav/>
            <PasteView {...params}/>
        {:else}
            <Splash/>
        {/if}
    {/if}
</main>


